export const POLICIES = {
  privacy: {
    title: "Privacy Policy",
    intro: "How Saarthva collects, uses and protects the information you share with us.",
    sections: [
      {
        heading: "What we collect",
        body: "When you submit an enquiry, request a quote or chat with our assistant, we collect the details you provide — such as your name, company, phone number, work email, city, requirement details and any files you choose to attach. We also keep a record of conversations with our AI assistant so we can follow up on your requirements.",
      },
      {
        heading: "How we use it",
        body: "We use this information only to respond to your enquiry, prepare quotations, coordinate sourcing or operations work you ask us to handle, and communicate with you on your preferred channel. We do not sell your information or share it with third parties except vendor partners strictly as needed to fulfil a requirement you have asked us to source.",
      },
      {
        heading: "Storage and retention",
        body: "Enquiry records and attachments are stored securely and retained while your enquiry or engagement is active, and for a reasonable period afterwards for our records. You may ask us to delete your information at any time by writing to support@saarthva.com.",
      },
      {
        heading: "Contact",
        body: "For any privacy question or request, write to support@saarthva.com or call / WhatsApp +91 92126 36329.",
      },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    intro: "The terms on which Saarthva provides procurement, sourcing and operations support services.",
    sections: [
      {
        heading: "Services",
        body: "Saarthva provides business-to-business procurement, sourcing, vendor coordination and operations support services. Specific requirements, quantities, pricing, timelines and service levels are confirmed per quotation or engagement communication before any order is placed on your behalf.",
      },
      {
        heading: "Quotations and orders",
        body: "A quotation is an offer based on information available at the time and may be revised if specifications, quantities, locations or market conditions change. An order is confirmed only when you approve a quotation in writing (including email or WhatsApp).",
      },
      {
        heading: "Your responsibilities",
        body: "You are responsible for sharing accurate requirements, specifications, delivery locations and approvals in a timely manner, and for inspecting deliveries on receipt so issues can be raised promptly.",
      },
      {
        heading: "Liability",
        body: "Saarthva coordinates sourcing and delivery through its vendor network and will make reasonable efforts to resolve issues. To the extent permitted by law, our liability for any claim is limited to the value of the specific order or engagement giving rise to the claim.",
      },
      {
        heading: "Governing law",
        body: "These terms are governed by the laws of India. Any dispute will be subject to the jurisdiction of courts in India.",
      },
    ],
  },
  "shipping-delivery": {
    title: "Shipping / Delivery Policy",
    intro: "How deliveries are coordinated across Saarthva's sourcing network.",
    sections: [
      {
        heading: "Timelines",
        body: "Delivery timelines are confirmed per quotation and depend on the category, quantity, sourcing location and your delivery location. We share an expected timeline with every quotation and keep you updated if anything changes.",
      },
      {
        heading: "Coverage",
        body: "Saarthva coordinates deliveries across major Indian business hubs through its sourcing and vendor network, with local partners handling last-mile delivery where applicable. Other locations can be supported based on the requirement.",
      },
      {
        heading: "Delivery and acceptance",
        body: "Please inspect deliveries on receipt. Any shortage, damage or mismatch should be reported to us promptly — ideally within 48 to 72 hours — with photographs where relevant, so we can coordinate resolution with the vendor.",
      },
      {
        heading: "Delays",
        body: "If a delay occurs, we will inform you proactively, share the revised timeline and offer alternatives where possible.",
      },
    ],
  },
  "returns-replacement": {
    title: "Returns / Replacement Policy",
    intro: "How Saarthva handles damaged, incorrect or defective supplies.",
    sections: [
      {
        heading: "Reporting an issue",
        body: "If an item arrives damaged, defective or not as per the approved specification, report it to us within 48 to 72 hours of delivery with photographs and your order reference. We will coordinate inspection and resolution with the vendor.",
      },
      {
        heading: "Resolution",
        body: "Depending on the category and the vendor's terms, resolution may be a replacement, repair, credit note or refund. We will confirm the applicable resolution for your order and follow it through to closure.",
      },
      {
        heading: "Custom and made-to-order items",
        body: "Custom-sourced, branded or made-to-order items (for example uniforms, gifting or fabricated components) cannot be returned unless defective or not as per the approved specification.",
      },
      {
        heading: "How to raise a request",
        body: "Write to support@saarthva.com or call / WhatsApp +91 92126 36329 with your order details.",
      },
    ],
  },
};
